import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-background px-6 py-12">
      <div className="max-w-2xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-primary hover:underline mb-8">
          <ArrowLeft size={16} /> Zurück
        </Link>
        <Logo className="mb-8" />
        <div className="bg-white border border-border rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-serif mb-6">Impressum</h1>
          <img src="/logo-pfarrei.png" alt="Pfarrei Mariä Himmelfahrt Otterberg" className="h-16 w-auto object-contain mb-6" data-testid="impressum-logo" />
          <div className="space-y-5 text-sm text-slate-700 leading-relaxed">
            <div className="space-y-0.5">
              <p className="font-semibold text-base">Verantwortlich für Inhalt</p>
              <p>Pfarrei Mariä Himmelfahrt</p>
              <p>vertreten durch Dr. Christoph Hartmüller, leitender Pfarrer</p>
              <p>Klosterstraße 17 • 67697 Otterberg</p>
              <p>Tel 06301-71832-0 • Fax 06301-71832-29</p>
              <p><a href="mailto:pfarramt.otterberg@bistum-speyer.de" className="text-primary hover:underline">pfarramt.otterberg@bistum-speyer.de</a></p>
              <p><a href="https://www.mariae-himmelfahrt.net" target="_blank" rel="noreferrer" className="text-primary hover:underline">www.mariae-himmelfahrt.net</a></p>
              <p>mariaehimmelfahrt4u</p>
            </div>
            <div className="space-y-0.5">
              <p className="font-semibold text-base">Verantwortlich für technische Koordination</p>
              <p>Michael Zimmermann</p>
              <p>Pfarrei Mariä Himmelfahrt</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
